export const onFirebaseLoginFailedHandler = (code, onError) => {
    switch (code) {
        case 'auth/invalid-email':
        case 'auth/wrong-password':
        case 'auth/user-not-found':
            onError('Niepoprawne dane do logowania');
            break;
        case 'auth/user-disabled':
            onError('Podane konto jest nieaktywne');
            break;
        case 'auth/network-request-failed':
            onError('Błąd połączenia');
            break;
        default:
            onError('Błąd logowania');
            break;
    }
};

export const onFirebaseCreateAccountFailedHandler = (code, onError) => {
    switch (code) {
        case 'auth/email-already-in-use':
            onError('Ten email jest już w użyciu');
            break;
        case 'auth/invalid-email':
            onError('Wprowadzony adres email jest niepoprawny');
            break;
        case 'auth/weak-password':
            onError('Hasło musi mieć minimum 6 znaków');
            break;
        case 'auth/network-request-failed':
            onError('Błąd połączenia');
            break;
        default:
            onError('Błąd podczas rejestracji');
            break;
    }
};
